export default __webpack_public_path__ + "static/media/DIY05.1ed8ed38.JPG";